/*
* Project: LegalPlace assistant
* File: src/components/misc/helper.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/

import React from 'react';

const LpHelper = props => (
  <div className="wz-helper">
    {<div dangerouslySetInnerHTML={{ __html: props.text }} />}
  </div>
);

export default LpHelper;



// WEBPACK FOOTER //
// ./src/components/misc/helper.js